import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { QRCodeSVG } from 'qrcode.react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiCopy, FiCheck, FiShare2 } = FiIcons;

function ShareModal({ sessionId, onClose }) {
  const [copied, setCopied] = useState(false);
  const sessionUrl = `${window.location.origin}/#/session/${sessionId}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(sessionUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const shareNative = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Kreuzworträtsel',
          text: 'Löse dieses Kreuzworträtsel mit mir!',
          url: sessionUrl,
        });
      } catch (err) {
        console.error('Error sharing:', err);
      }
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="bg-white rounded-lg p-6 max-w-md w-full"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-semibold text-primary font-rubik">
            Rätsel teilen
          </h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <SafeIcon icon={FiX} className="text-primary" />
          </button>
        </div>

        <div className="text-center mb-6">
          <div className="bg-white p-4 rounded-lg border-2 border-gray-200 inline-block">
            <QRCodeSVG 
              value={sessionUrl} 
              size={200}
              level="M"
              includeMargin={true}
            />
          </div>
          <p className="text-sm text-primary mt-2 font-rubik">
            QR-Code scannen zum direkten Zugriff
          </p>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-primary mb-2 font-rubik">
            Session-URL
          </label>
          <div className="flex gap-2">
            <input
              type="text"
              value={sessionUrl}
              readOnly
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-sm text-primary font-rubik"
            />
            <button
              onClick={copyToClipboard}
              className={`px-4 py-2 rounded-md transition-colors flex items-center gap-2 font-rubik ${
                copied 
                  ? 'bg-button text-white' 
                  : 'bg-button hover:bg-button-hover text-white'
              }`}
            >
              <SafeIcon icon={copied ? FiCheck : FiCopy} className="text-sm" />
              {copied ? 'Kopiert!' : 'Kopieren'}
            </button>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 text-primary rounded-md hover:bg-gray-50 transition-colors font-rubik"
          >
            Schließen
          </button>
          
          {navigator.share && (
            <button
              onClick={shareNative}
              className="flex-1 px-4 py-2 bg-button text-white rounded-md hover:bg-button-hover transition-colors flex items-center justify-center gap-2 font-rubik"
            >
              <SafeIcon icon={FiShare2} className="text-sm" />
              Teilen
            </button>
          )}
        </div>

        <div className="mt-4 p-3 bg-gray-50 rounded-lg">
          <p className="text-sm text-primary font-rubik">
            <strong>Tipp:</strong> Andere können über diese URL direkt mitmachen - 
            kein Login erforderlich!
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
}

export default ShareModal;